// extracted by mini-css-extract-plugin
module.exports = {"container":"scheduled-item-container__1db3w","header":"scheduled-item-header__3HOLP","text_block":"scheduled-item-text_block__3vZvF"};